module.exports = __webpack_public_path__ + "static/media/online.5138bf8e.svg";